import App from "apps/incognito_packages/components/App";
import { connect } from "react-redux";

import {
	toggleModalVisibility,
} from "ducks/incognito_packages";

export const mapStateToProps = (state) => ({
	...state.incognitoPackages,

	// add the mobile flag in here, why not
	isMobile: process.env.PLATFORM === "mobile",
});

export const mapDispatchToProps = (dispatch) => ({
	toggleModalVisibility(isVisible) {
		dispatch(toggleModalVisibility(isVisible));
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/apps/incognito_packages/containers/App.jsx